var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoxIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.86458 6.80312H4.38542V6.11562H1.86458V6.80312ZM3.23958 4.84375H5.76042V4.15625H3.23958V4.84375ZM4.61458 2.88438H7.13542V2.19688H4.61458V2.88438ZM1.0625 8.625C0.879167 8.625 0.71875 8.55625 0.58125 8.41875C0.44375 8.28125 0.375 8.12083 0.375 7.9375V1.0625C0.375 0.879167 0.44375 0.71875 0.58125 0.58125C0.71875 0.44375 0.879167 0.375 1.0625 0.375H7.9375C8.12083 0.375 8.28125 0.44375 8.41875 0.58125C8.55625 0.71875 8.625 0.879167 8.625 1.0625V7.9375C8.625 8.12083 8.55625 8.28125 8.41875 8.41875C8.28125 8.55625 8.12083 8.625 7.9375 8.625H1.0625ZM1.0625 7.9375H7.9375V1.0625H1.0625V7.9375Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxIcon);
export default __webpack_public_path__ + "static/media/boxIcon.4a347dfdb92b91f5e7a4c43989b6856d.svg";
export { ForwardRef as ReactComponent };